export default {
  /**
   * @description maximo de palavras e adiciona ellipse ao final
   * @argument numero
   */
  shortWords: (value, max) => {
    if (value) {
      if (value.length > max) {
        const shortString = value.substr(0, max);
        return shortString
          .substr(0, Math.min(shortString.length, shortString.lastIndexOf(' ')))
          .concat('...');
      }
      return value;
    }
    return value;
  },
  shortName: (value, max) => {
    if (value) {
      if (value.length > max) {
        const shortString = value.substr(0, max);
        return shortString.substr(0, Math.min(shortString.length, shortString.lastIndexOf(' ')));
      }
      return value;
    }
    return value;
  },
  /**
   *
   * @param value
   * @param locale
   * @returns {string}
   */
  showDate: (value, locale = 'pt-BR') => {
    const dt = new Date(value);
    return dt.toLocaleDateString(locale);
  },
  /**
   * Capitalize Words
   * @param value
   * @returns {string}
   */
  capitalize(value) {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
  },

  /**
   * Uppercase Words
   * @param value
   * @returns {string}
   */
  uppercase(value) {
    if (!value) return '';
    value = value.toLocaleUpperCase();
    return value;
  },

  /**
   * Converter Moeda
   * @param number
   * @param intl
   * @param currency
   * @returns {string|*}
   */
  convertMoeda(number, intl = 'pt-BR', currency = 'BRL') {
    if (!number && number !== 0) return '';
    const value = new Intl.NumberFormat(intl, { minimumFractionDigits: 2, currency }).format(
      number,
    );
    return value;
  },

  nameBreadcrumb(value) {
    if (value) {
      const v = value.replace(/(?:[-._])/g, ' ');
      return v.charAt(0).toUpperCase() + v.slice(1);
    }
    return '';
  },
};
